import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProfileAlert } from "../types";

export const getProfileAlert = (billingProfileId: string) => {
  return apiProxyRequest<ProfileAlert[]>(
    `/billing/profiles/${billingProfileId}/alerts/billing`
  );
};
